import React from 'react';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import 'Components/frameworks/dynamic-link/DynamicLink';
import type { TextProps } from 'Components/frameworks/text/Text';
import { Text } from 'Components/frameworks/text/Text';
import type { CardHeadingProps } from './card-heading/CardHeading';
import { CardHeading } from './card-heading/CardHeading';
import { themes } from './CardHeader.themes';
type Props = {
  color?: Colors;
  dataTestIdPrefix?: string;
  heading?: CardHeadingProps;
  introduction?: TextProps;
  link?: DynamicLinkProps | null | undefined;
  theme?: keyof typeof themes;
};
export const CardHeader = ({
  color,
  dataTestIdPrefix = 'CardHeader',
  heading,
  introduction,
  link,
  theme = 'default',
}: Props) => {
  const { thIntro } = themes[theme];
  return (
    <header>
      <CardHeading
        {...heading}
        color={color}
        dataTestIdPrefix={dataTestIdPrefix}
        link={link}
        theme={theme}
      />
      {!!introduction && (
        <Text
          {...introduction}
          className={thIntro}
          data-testid={`${dataTestIdPrefix}-introduction`}
        />
      )}
    </header>
  );
};
